import { useAuth0 } from "@auth0/auth0-react";
import config from "@core/config";
import { MockAuthService } from "@services";
import { useCallback, useEffect, useRef, useState } from "react";

export function useAuth0Token() {
  const { getAccessTokenSilently } = useAuth0();

  const isAcquireTokenInProgress = useRef<boolean>(false);
  const [auth0AccessToken, setAuth0AccessToken] = useState<string>();
  const getToken = useCallback(async () => {
    try {
      if (MockAuthService.isEnabled && MockAuthService.isAuthorized) {
        setAuth0AccessToken("MOCK_AZURE_TOKEN");
        return "MOCK_AZURE_TOKEN";
      }

      const accessToken = await getAccessTokenSilently({
        authorizationParams: {
          audience: `https://${config.AUTH0_DOMAIN}/api/v2/`,
          scope: config.AUTH0_READ_SCOPE,
        },
      });
      if (auth0AccessToken !== accessToken) setAuth0AccessToken(accessToken);

      return accessToken;
    } catch (e) {
      console.error(e.message);
    }
  }, [getAccessTokenSilently, auth0AccessToken]);

  useEffect(() => {
    async function fetchData() {
      try {
        isAcquireTokenInProgress.current = true;

        const token = await getToken();
        setAuth0AccessToken(token);

        isAcquireTokenInProgress.current = false;
      } catch (_) {
        isAcquireTokenInProgress.current = false;
      }
    }

    if (!isAcquireTokenInProgress.current) {
      fetchData();
    }
  }, [getToken]);

  return {
    auth0AccessToken,
    getToken,
  };
}
